import { type } from "@testing-library/user-event/dist/type";
import { Menu } from "antd";
import { useNavigate } from "react-router-dom";

const CompetitionsMenu = ({ afterItemClick }) => {
  const navigate = useNavigate();

  const defaultCompetitionId = 39;
  const widgets = [
    {
      key: "widgets",
      label: "Widgets",
      type: "group",
      children: [
        {
          key: "standings",
          widget: "standings",
          label: "Classement",
        },
        {
          key: "fixtures",
          label: "Matchs",
          widget: "fixtures",
        },
      ],
    },
  ];

  return (
    <Menu
      mode="inline"
      onClick={({ key }) => {
        navigate(
          `/preview?competitionId=${defaultCompetitionId}&widget=${key}`
        );
        if (afterItemClick) afterItemClick();
      }}
      items={widgets}
    />
  );
};

export default CompetitionsMenu;
